import { useMutation } from '@tanstack/react-query';
import { omit } from 'ramda';
import { TableCell, Typography } from '@mui/material';

import { ApiAudit, RouteEnum, generateRoutePath, useGotoRoute } from 'App';
import { IAudit, auditStatus } from '@shared';
import { ViewLink } from '.';

type TypeProps = {
  item: IAudit;
  pathname: string;
  closeModal: () => void;
};

export function AuditCell({ item, pathname, closeModal }: TypeProps) {
  const goToRoute = useGotoRoute(RouteEnum.EnhancedAudit);
  const { sessionUuid, auditUuid, ...rest } = omit(
    ['uuid', 'partnerUuid', 'courseUuid', 'examUuid'],
    item
  );

  const { mutate: startAudit, isLoading } = useMutation({
    mutationFn: () => ApiAudit.startAudit(sessionUuid),
    onSuccess: (data) => goToRoute({ audit: data.auditUuid }),
  });

  const labelButton = rest.status === auditStatus.IN_QUEUE ? 'Start' : 'View';
  const to =
    rest.status === auditStatus.IN_QUEUE
      ? pathname
      : generateRoutePath({
          name: RouteEnum.Review,
          params: { session: sessionUuid, audit: auditUuid || '' },
        });
  const onClose = pathname === to ? closeModal : () => null;

  return (
    <>
      {Object.values(rest).map((i, index) => (
        <TableCell size='small' key={index}>
          <Typography component='span' variant='tableCell'>
            {i as string}
          </Typography>
        </TableCell>
      ))}
      <ViewLink
        label={labelButton}
        to={to}
        isLoading={isLoading}
        onClick={rest.status === auditStatus.IN_QUEUE ? startAudit : onClose}
      />
    </>
  );
}
